import axios from 'axios';
import React, { useState, useEffect } from 'react';

const UserForm = ({ onClose, roolId }) => {
  const [roleData, setRoleData] = useState([]);
  const [formValues, setFormValues] = useState({
    firstName: '',
    lastName: '',
    email: '',
    contactNo: '',
    password: '',
    roolSection: '',
    roleData,
  });

  const [roolSectionData, setRoolSectionData] = useState([]);

  const [error, setError] = useState({
    phoneNumber: '',
    email: '',
    password: '',
  });

  const fetchRools = async () => {
    try {
      const response = await axios.get(`http://localhost:4000/getrool`);
      setRoolSectionData(response.data.Rool);
    } catch (error) {
      console.error('Error fetching rools:', error);
    }
  };

  useEffect(() => {
    fetchRools();
  }, []);

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    let phoneNumberError = '';
    let emailError = '';
    let passwordError = '';

    if (name === "contactNo") {
      const phoneNumberPattern = /^[6-9]\d{9}$/;
      if (!phoneNumberPattern.test(value)) {
        phoneNumberError = "Invalid phone number. Please enter a valid 10-digit Indian phone number.";
      }
      value = value.replace(/[^0-9]/g, '');
    }

    if (name === "email") {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;
      if (!emailPattern.test(value)) {
        emailError = "Invalid email address.";
      }
    }

    if (name === "password") {
        const passwordPattern = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;
        if (!passwordPattern.test(value)) {
          passwordError =
            "Password must be at least 8 characters long, include 1 uppercase letter, 1 number, and 1 special character.";
        }
      }
      
    setError({
      ...error,
      phoneNumber: phoneNumberError,
      email: emailError,
      password: passwordError,
    });

    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Convert roolSection to an array if it's not already
    const roolSectionArray = Array.isArray(formValues.roolSection)
        ? formValues.roolSection
        : [formValues.roolSection];

    // Find matching roles
    const matchedRoles = roolSectionData.filter((role) =>
        roolSectionArray.includes(role.roolId.toString())
    );

    console.log("Matched Roles:", matchedRoles);

    // Extract role names properly
    const roleNames = matchedRoles.flatMap(role => role.name.map(n => n));

    const requestData = {
        formValues: {
            ...formValues,
            roleData: roleNames,
        },
    };

    console.log("Final requestData:", requestData);

    try {
        const response = await axios.post('http://localhost:4000/admincreate', requestData);
        console.log('Response:', response.data);

        if (typeof onClose === 'function') {
            console.log("Closing section...");
            onClose();
        }
    } catch (error) {
        console.error('Error creating/updating application:', error);
        console.error("Error Response Data:", error.response?.data);
    }
};
  


  return (
    <div className="modal fade show" aria-modal="true" role="dialog" style={{ display: "block" }}>
      <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Create Admin</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body ">
          <form id="formAuthentication" className="mb-3" onSubmit={handleSubmit}>
        <div className="mb-2">
          <label htmlFor="firstName" className="form-label">
            First Name <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="firstName"
            name="firstName"
            placeholder="Enter Your First Name"
            value={formValues.firstName}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="mb-2">
          <label htmlFor="lastName" className="form-label">
            Last Name <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="lastName"
            name="lastName"
            placeholder="Enter Your Last Name"
            value={formValues.lastName}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="mb-2">
          <label htmlFor="email" className="form-label">
            Email
          </label>
          <input
            type="email"
            id="email"
            className="form-control"
            name="email"
            placeholder="Enter Your Email Address"
            value={formValues.email}
            onChange={handleInputChange}
          />
          {error.email && <div style={{ color: 'red' }}>{error.email}</div>}
        </div>
        <div className="mb-2">
          <label htmlFor="phoneNumber" className="form-label">
            Phone Number <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="tel"
            pattern="[0-9]*"
            className="form-control mb-2 no-arrows"
            id="contactNo"
            name="contactNo"
            placeholder="Enter Your Phone Number"
            value={formValues.contactNo}
            onChange={handleInputChange}
            maxLength="10"
            required
          />
          {error.phoneNumber && <div style={{ color: 'red' }}>{error.phoneNumber}</div>}
        </div>
        <div className="mb-3">
          <label className="form-label" htmlFor="password">
            Password <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="password"
            id="password"
            className="form-control mb-2"
            name="password"
            placeholder="Enter Your Password"
            value={formValues.password}
            onChange={handleInputChange}
            required
          />
          {error.password && <div style={{ color: 'red' }}>{error.password}</div>}
        </div>
      
        <div className="mb-3">
          <label className="form-label" htmlFor="roolSection">
            Role <span style={{ color: "red" }}>*</span>
          </label>
          <select
            id="roolSection"
            className="form-control mb-2"
            name="roolSection"
            value={formValues.roolSection}
            onChange={handleInputChange}
            required
          >
            <option value="">Select Role</option>
            {roolSectionData.map((rool) => (
              <option key={rool.roolId} value={rool.roolId}>
                {rool.roolname}
              </option>
            ))}
          </select>
        </div>
       
        <div className="mb-3">
          <button type="submit" className="btn btn-primary d-grid w-30">
            Create
          </button>
        </div>
      </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserForm;
